export default function ($translate) {
    return {
        KEYS: {
            EURO: 'EURO',
            DOLLAR: 'DOLLAR',
            POUND: 'POUND'
        },
        LABELS: {
            EURO: $translate.instant('courses.external.Euro sign'),
            DOLLAR: $translate.instant('courses.external.Dollar sign'),
            POUND: $translate.instant('courses.external.Pound sign')
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/enums/course/priceType/index.js